module.exports = __webpack_public_path__ + "img/download.23a63f97.svg";